export default {
    owned: true,
    hasCustomNavbar: true,
    hasCustomBackground: true,
    hasAnimations: true
} 